import React, { FC } from 'react';
import { SubHeaderRails } from '../../../components/sub-header/SubHeaderRails';
import { LawyerActionSlider } from './LawyerActionSlider';
import { MobileBar } from '../../../components/mobile-bar/MobileBar';

type Props = {
  isVisible: boolean;
};

export const LawyerMobileBar: FC<Props> = ({ isVisible }) => (
  <MobileBar>
    <SubHeaderRails>
      <LawyerActionSlider isVisible={isVisible} />
    </SubHeaderRails>
  </MobileBar>
);
